/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : MultipleVariants.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ViewVCDetails from "./ViewVCDetails";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ShowLogsDetails from "./ShowLogsDetails";
import CustomTabsV2 from "../common/tabs/CustomTabsV2";

function MultipleVariants({
  variant,
  expanded,
  onToggle,
  logs,
  loading,
  setExpandVCLogs,
  vehicleStatusData,
  expandVCLogs,
  handleEditClick,
  logsCount,
  pageVCLogCount,
  rowsPerPageVCLogCount,
  handlePageChangeLogsVC,
}) {
  const variantDetails = [
    {
      label: "Vehicle Status",
      value: variant?.vehicle_status,
      editable: true,
      optionsList: Array.isArray(vehicleStatusData)
        ? vehicleStatusData.map((item) => ({
          label: item?.name,
          value: item?.name,
        }))
        : [],
    },
    { label: "Delivery Market", value: variant?.delivery_market },
    {
      label: "Manufacture Name",
      value: variant?.mft_details?.name,
    },
    {
      label: "Manufacturer Address",
      value: variant?.mft_details?.address,
    },
    { label: "Model Year", value: variant?.production_year },

    { label: "Variant Color", value: variant?.color_code, editable: true },
    {
      label: "Power Train Class",
      value: variant?.powertrain_class_details?.[0]?.name,
    },
  ];
  const tabsDataVariant = [
    {
      name: "Details",
      count: "",
      content: (
        <ViewVCDetails
          variant={variant}
          variantDetails={variantDetails}
          handleEditClick={handleEditClick}
        />
      ),
    },
    {
      name: "Logs",
      count: logsCount || "",
      content: (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ShowLogsDetails
            expanded={expandVCLogs}
            setExpanded={setExpandVCLogs}
            logs={logs}
            loading={loading}
            page={pageVCLogCount}
            rowsPerPage={rowsPerPageVCLogCount}
            logsCount={logsCount}
            onPageChange={handlePageChangeLogsVC}
          />
        </LocalizationProvider>
      ),
    },
  ];
  return (
    <Box sx={{ width: "100%" }}>
      <Accordion
        expanded={expanded}
        sx={{
          boxShadow: 3,
          borderRadius: 0,
          backgroundColor: "#f9f9f9",
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          onClick={onToggle}
          expandIcon={
            expanded ? (
              <ExpandMoreIcon sx={{ color: "white" }} />
            ) : (
              <ExpandMoreIcon sx={{ color: "white" }} />
            )
          }
          sx={{
            backgroundColor: "black",
            color: "white",
            minHeight: "48px !important",
            "& .MuiAccordionSummary-content": {
              margin: "8px 0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, fontFamily: "Manrope, sans-serif" }}
          >
            {variant?.name}
          </Typography>
        </AccordionSummary>

        <AccordionDetails sx={{ backgroundColor: "white", p: 2 }}>
          <Box>
            <CustomTabsV2 tabs={tabsDataVariant} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default MultipleVariants;
